<template>
    <div class="user-questionnaire-form-container w-100 user-modal-register-view px-2" :style="containerStyle">
        <template>
            <div class="w-100 mb-4">
                <div class="mb-2 text-center">
                    <p class="font-weight-bold font-size-200 mb-0">{{ 'Tell us about yourself' | trans }}</p>
                </div>
                <div class="mb-2 text-center py-2">
                    {{ "And we'll personalize your experience for %project%!" | trans({ '%project%': projectName }) }}
                </div>

                <DotNavigation></DotNavigation>

                <div class="text-center py-2 mb-2">
                    <strong>{{ 'What do you use %project% for?' | trans({ '%project%': projectName }) }}</strong>
                </div>

                <div v-if="isStatusDone">
                    <div class="mb-3">
                        <button
                            class="btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow"
                            @click.stop.prevent="
                                dataValue = 'Personal use';
                                goToHowDoYouUseTheProject();
                            "
                            :class="{
                                'btn, btn-info': dataValue === 'Personal use',
                                'btn btn-white': dataValue !== 'Personal use',
                            }"
                            :disabled="isSubmitting"
                        >
                            {{ 'Personal use' | trans }}
                        </button>
                    </div>

                    <div class="mb-3">
                        <button
                            class="btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow"
                            @click.stop.prevent="
                                dataValue = 'At work where I am employed';
                                goToHowDoYouUseTheProject();
                            "
                            :class="{
                                'btn, btn-info': dataValue === 'At work where I am employed',
                                'btn btn-white': dataValue !== 'At work where I am employed',
                            }"
                            :disabled="isSubmitting"
                        >
                            {{ 'At work where I am employed' | trans }}
                        </button>
                    </div>

                    <div class="mb-5">
                        <button
                            class="btn-block p-2 d-flex align-items-center justify-content-center border rounded btn-lg no-shadow"
                            @click.stop.prevent="
                                dataValue = 'My own business';
                                goToHowDoYouUseTheProject();
                            "
                            :class="{
                                'btn, btn-info': dataValue === 'My own business',
                                'btn btn-white': dataValue !== 'My own business',
                            }"
                            :disabled="isSubmitting"
                        >
                            {{ 'My own business' | trans }}
                        </button>
                    </div>
                    <div>
                        <!--                        <ButtonWithLoadingState-->
                        <!--                            data-user-modal-button-submit-->
                        <!--                            class="btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4"-->
                        <!--                            icon="fa fa-arrow-right lh-1"-->
                        <!--                            :text="'Continue' | trans"-->
                        <!--                            :is-state-loading="isSubmitting"-->
                        <!--                            :show-icon-after-text="true"-->
                        <!--                            @click.stop.prevent="goToHowDoYouUseTheProject"-->
                        <!--                        ></ButtonWithLoadingState>-->
                    </div>
                </div>

                <LoadingAnimation v-else-if="isStatusLoading" animation-style="bars" classes="mb-4"></LoadingAnimation>
            </div>
        </template>
    </div>
</template>

<script>
import LoadingAnimation from '../../../../../qaamgo/modules/sat/components/LoadingAnimation';
import DataStatus from '../../../../../qaamgo/modules/sat/components/mixins/DataStatus';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { userQuestionnaireModalHelper } from '../user-questionnaire-modal-helper';
import { satGlobals } from '../../../../../qaamgo/sat/helper/sat-globals';
import ButtonWithLoadingState from '../../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import { userQuestionnaireModalRoute } from '../router';
import DotNavigation from '../components/DotNavigationComponent';
import { pageStoreMixin } from '../../../../store/page-store';

export default {
    name: 'ProjectUsageForm',
    components: { DotNavigation, LoadingAnimation, ButtonWithLoadingState },
    mixins: [DataStatus, TransFilter, pageStoreMixin],
    mounted() {
        this.setStatusDone();
    },
    methods: {
        saveProfile() {
            if (this.dataValue === '') {
                return Promise.resolve();
            }

            const profiles = [{ user_type: this.dataValue }];

            return userQuestionnaireModalHelper.saveProfile(profiles);
        },
        goToHowDoYouUseTheProject() {
            this.saveProfile()
                .then(() => {
                    this.$router.push({
                        name: userQuestionnaireModalRoute.HOW_PROJECT_USE,
                    });
                })
                .finally(() => {
                    this.setStatusDone();
                });
        },
    },
    computed: {
        /** @return {Boolean} */
        isSubmitting() {
            return this.store.questionnaireModal.getSubmitting;
        },
    },
    props: {
        containerStyle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            userQuestionnaireModalRoute: userQuestionnaireModalRoute,
            csrfToken: '',
            projectName: satGlobals.getProjectName(),
            dataValue: '',
        };
    },
};
</script>
